import { render, staticRenderFns } from "./channelItemData.vue?vue&type=template&id=6f0c5fac"
import script from "./channelItemData.vue?vue&type=script&lang=js"
export * from "./channelItemData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports